/* KÔBO — grains de café 3D (three.js, chargé à l'apparition de la section) */
const root = document.querySelector('[data-k-beans]');
if (root) {
  const cv = root.querySelector('.k-beans-cv'), fallback = root.querySelector('.k-beans-fallback');
  const q = (s) => root.querySelector(s);
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp = (a, b, t) => a + (b - a) * t;

  /* ---------- données de torréfaction ---------- */
  const STOPS = [
    { r: 0,   name: 'Claire',           temp: 196, loss: 12, time: 9,  col: [0.66, 0.46, 0.24], rough: 0.78, acid: 9, sweet: 4, bitter: 1, body: 3, notes: ['fruits rouges', 'floral', 'agrumes', 'thé noir'] },
    { r: 38,  name: 'Moyenne',          temp: 210, loss: 15, time: 11, col: [0.36, 0.21, 0.11], rough: 0.55, acid: 6, sweet: 8, bitter: 3, body: 6, notes: ['caramel', 'noisette', 'chocolat au lait', 'fruits secs'] },
    { r: 70,  name: 'Moyenne-foncée',   temp: 224, loss: 17, time: 12, col: [0.20, 0.11, 0.06], rough: 0.4, acid: 3, sweet: 6, bitter: 6, body: 8, notes: ['cacao', 'épices', 'vanille brûlée', 'boisé'] },
    { r: 100, name: 'Foncée',           temp: 240, loss: 20, time: 14, col: [0.10, 0.06, 0.035], rough: 0.26, acid: 1, sweet: 3, bitter: 9, body: 9, notes: ['cacao amer', 'fumé', 'réglisse', 'torréfié'] },
  ];
  const at = (r) => { let i = 0; while (i < STOPS.length - 2 && r > STOPS[i + 1].r) i++; const a = STOPS[i], b = STOPS[i + 1], t = clamp((r - a.r) / (b.r - a.r), 0, 1); return { a, b, t, near: t < 0.5 ? a : b }; };

  /* ---------- UI ---------- */
  const inp = q('[data-roast-in]'), nameEl = q('[data-roast-name]'), tEl = q('[data-roast-temp]'), lEl = q('[data-roast-loss]'), dEl = q('[data-roast-time]');
  const bars = {}; root.querySelectorAll('[data-bar]').forEach((b) => (bars[b.dataset.bar] = b));
  const notesEl = q('[data-roast-notes]'), curve = q('.k-roast-curve .line'), pt = q('.k-roast-curve .pt');
  let shownNotes = '';
  const setUI = (r, mat) => {
    const { a, b, t, near } = at(r);
    nameEl.textContent = near.name; tEl.textContent = Math.round(lerp(a.temp, b.temp, t)) + ' °C'; lEl.textContent = Math.round(lerp(a.loss, b.loss, t)) + ' %'; dEl.textContent = Math.round(lerp(a.time, b.time, t)) + ' min';
    ['acid', 'sweet', 'bitter', 'body'].forEach((k) => (bars[k].style.width = lerp(a[k], b[k], t) * 10 + '%'));
    const key = near.name; if (key !== shownNotes) { shownNotes = key; notesEl.innerHTML = near.notes.map((n) => '<span>' + n + '</span>').join(''); }
    /* courbe : montée en température jusqu'au point choisi */
    const T = lerp(a.time, b.time, t), pts = []; for (let i = 0; i <= 20; i++) { const x = (i / 20) * 300, k = i / 20; pts.push([x, 80 - (Math.pow(k, 0.55) * 60)]); }
    curve.setAttribute('d', 'M' + pts.map((p) => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' L'));
    const px = clamp((T - 8) / 7, 0, 1) * 300, py = 80 - Math.pow(px / 300, 0.55) * 60; pt.setAttribute('cx', px); pt.setAttribute('cy', py);
  };

  let THREE, renderer, scene, camera, beans, N = 190, dummy, state = [], color = null, mat, visible = false, started = false, pointer = { x: -9, y: -9, on: false }, raycaster, plane, hit;
  const R = 5.4, mound = (x, z) => 2.1 * Math.max(0, 1 - (x * x + z * z) / (R * R));

  async function start() {
    if (started) return; started = true;
    try { THREE = await import('three'); } catch (e) { cv.hidden = true; fallback.hidden = false; return; }
    try { renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true }); } catch (e) { cv.hidden = true; fallback.hidden = false; return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2)); renderer.outputColorSpace = THREE.SRGBColorSpace; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 0.95;
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100); camera.position.set(0, 10.5, 17.5); camera.lookAt(0, 1.2, 0);
    scene.add(new THREE.HemisphereLight(0xfff1dc, 0x1a0e06, 0.5));
    const key = new THREE.DirectionalLight(0xffe2b8, 2.1); key.position.set(5, 11, 6); scene.add(key);
    const rim = new THREE.DirectionalLight(0x9ec1ff, 1.0); rim.position.set(-8, 5, -6); scene.add(rim);
    const fill = new THREE.PointLight(0xffb066, 22, 30); fill.position.set(0, 3, 8); scene.add(fill);

    /* grain : ellipsoïde avec sillon central */
    const g = new THREE.SphereGeometry(1, 30, 22); const pos = g.attributes.position;
    for (let i = 0; i < pos.count; i++) {
      let x = pos.getX(i) * 1.0, y = pos.getY(i) * 0.68, z = pos.getZ(i) * 0.5;
      if (z > 0) { const d = Math.max(0, 1 - Math.abs(y) / 0.1); z -= 0.17 * d * Math.sqrt(Math.max(0, 1 - x * x)); }
      pos.setXYZ(i, x, y, z);
    }
    g.computeVertexNormals();
    mat = new THREE.MeshStandardMaterial({ color: 0x5b3316, roughness: 0.55, metalness: 0.04 });
    beans = new THREE.InstancedMesh(g, mat, N); beans.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    const c = new THREE.Color(); for (let i = 0; i < N; i++) { const s = 0.82 + Math.random() * 0.36; c.setRGB(s, s * (0.96 + Math.random() * 0.08), s * (0.94 + Math.random() * 0.1)); beans.setColorAt(i, c); }
    scene.add(beans); dummy = new THREE.Object3D(); raycaster = new THREE.Raycaster(); plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.2); hit = new THREE.Vector3();

    for (let i = 0; i < N; i++) {
      const a = Math.random() * Math.PI * 2, r = Math.sqrt(Math.random()) * R * 0.95;
      const x = Math.cos(a) * r, z = Math.sin(a) * r * 0.75;
      state.push({ p: new THREE.Vector3(x, mound(x, z) + 0.6 + Math.random() * 3.2, z), v: new THREE.Vector3(), q: new THREE.Quaternion().setFromEuler(new THREE.Euler(Math.random() * 6.28, Math.random() * 6.28, Math.random() * 6.28)), w: new THREE.Vector3(), s: 0.62 + Math.random() * 0.14, rest: 0.3 + Math.random() * 0.25 });
    }
    resize(); window.addEventListener('resize', resize);
    setRoast(+inp.value); settle(140); requestAnimationFrame(loop);
  }

  function resize() { if (!renderer) return; const r = cv.getBoundingClientRect(); renderer.setSize(r.width, r.height, false); camera.aspect = r.width / r.height; camera.fov = r.width < 700 ? 52 : 38; camera.updateProjectionMatrix(); }

  function setRoast(r) {
    if (mat) { const { a, b, t } = at(r); mat.color.setRGB(lerp(a.col[0], b.col[0], t), lerp(a.col[1], b.col[1], t), lerp(a.col[2], b.col[2], t), THREE.SRGBColorSpace); mat.roughness = lerp(a.rough, b.rough, t); }
    setUI(r);
  }
  inp.addEventListener('input', () => setRoast(+inp.value));

  cv.addEventListener('pointermove', (e) => { const r = cv.getBoundingClientRect(); pointer.x = ((e.clientX - r.left) / r.width) * 2 - 1; pointer.y = -((e.clientY - r.top) / r.height) * 2 + 1; pointer.on = true; root.classList.add('is-touched'); });
  cv.addEventListener('pointerleave', () => (pointer.on = false));
  cv.addEventListener('pointerdown', (e) => { pointer.on = true; cv.setPointerCapture(e.pointerId); pulse(2.6); });
  function pulse(power) { if (!hit) return; raycaster.setFromCamera(pointer, camera); if (!raycaster.ray.intersectPlane(plane, hit)) return; state.forEach((s) => { const d = s.p.distanceTo(hit); if (d < 4) { const dir = s.p.clone().sub(hit).normalize(); s.v.addScaledVector(dir, power * (1 - d / 4) * 2.5); s.v.y += power * (1 - d / 4) * 3; s.w.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).multiplyScalar(14); } }); }
  q('[data-beans-pour]').addEventListener('click', () => { state.forEach((s, i) => { s.p.set((Math.random() - 0.5) * 8, 7 + Math.random() * 16, (Math.random() - 0.5) * 6); s.v.set((Math.random() - 0.5) * 1.2, 0, (Math.random() - 0.5) * 1.2); s.w.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).multiplyScalar(8); }); });

  /* ---------- physique : 2 sphères par grain (capsule) + collisions entre grains ---------- */
  let last = 0;
  let V = null;
  function tools() { if (V) return; V = { a: new THREE.Vector3(), b: new THREE.Vector3(), n: new THREE.Vector3(), up: new THREE.Vector3(0, 1, 0), z: new THREE.Vector3(), dq: new THREE.Quaternion(), tq: new THREE.Quaternion(), ro: new THREE.Vector3(), ax: new THREE.Vector3() }; }
  const SEG = 0.5;    /* décalage des sphères le long du grain (x taille) */
  const RAD = 0.62;   /* rayon des sphères (x taille) */

  function step(dt, mouse3) {
    tools();
    const sc = 1.15;
    for (let i = 0; i < N; i++) {
      const s = state[i];
      s.v.y -= 22 * dt;
      if (mouse3) { const dx = s.p.x - mouse3.x, dz = s.p.z - mouse3.z, dy = s.p.y - mouse3.y, d = Math.hypot(dx, dy, dz); if (d < 2.4) { const f = (1 - d / 2.4) * 42 * dt; s.v.x += (dx / (d || 1)) * f; s.v.z += (dz / (d || 1)) * f; s.v.y += f * 0.9; s.w.x += (Math.random() - 0.5) * 6 * f; s.w.z += (Math.random() - 0.5) * 6 * f; } }
      s.p.addScaledVector(s.v, dt);
      const wl = s.w.length(); if (wl > 0.001) { V.ax.copy(s.w).normalize(); V.dq.setFromAxisAngle(V.ax, wl * dt); s.q.premultiply(V.dq).normalize(); }
      s.v.multiplyScalar(1 - 0.6 * dt); s.w.multiplyScalar(1 - 1.5 * dt); s.touch = false;
    }
    /* itérations de contraintes : sol + grain contre grain */
    for (let it = 0; it < 4; it++) {
      for (let i = 0; i < N; i++) {
        const s = state[i], sz = s.s * sc, off = SEG * sz, r = RAD * sz;
        V.ax.set(1, 0, 0).applyQuaternion(s.q);
        for (let k = -1; k <= 1; k += 2) {
          const py = s.p.y + V.ax.y * off * k, px = s.p.x + V.ax.x * off * k, pz = s.p.z + V.ax.z * off * k;
          const h = mound(px, pz) + r * 0.86;
          if (py < h) {
            const push = h - py; s.p.y += push; if (s.v.y < 0) s.v.y *= -0.18; s.touch = true;
            V.ro.set(V.ax.x * off * k, V.ax.y * off * k, V.ax.z * off * k); V.n.crossVectors(V.ro, V.up); s.w.addScaledVector(V.n, push * 4);
            s.v.x *= 1 - 3 * dt; s.v.z *= 1 - 3 * dt;
          }
        }
      }
      for (let i = 0; i < N; i++) {
        const A = state[i], sa = A.s * sc, offA = SEG * sa, rA = RAD * sa;
        V.ax.set(1, 0, 0).applyQuaternion(A.q); const ax = V.ax.x, ay = V.ax.y, az = V.ax.z;
        for (let j = i + 1; j < N; j++) {
          const B = state[j], sb = B.s * sc, reach = offA + rA + SEG * sb + RAD * sb;
          const dx0 = A.p.x - B.p.x, dy0 = A.p.y - B.p.y, dz0 = A.p.z - B.p.z;
          if (dx0 * dx0 + dy0 * dy0 + dz0 * dz0 > reach * reach) continue;
          const bx = V.a.set(1, 0, 0).applyQuaternion(B.q);
          const offB = SEG * sb, rB = RAD * sb, min = rA + rB;
          for (let ka = -1; ka <= 1; ka += 2) for (let kb = -1; kb <= 1; kb += 2) {
            const pax = A.p.x + ax * offA * ka, pay = A.p.y + ay * offA * ka, paz = A.p.z + az * offA * ka;
            const pbx = B.p.x + bx.x * offB * kb, pby = B.p.y + bx.y * offB * kb, pbz = B.p.z + bx.z * offB * kb;
            const dx = pax - pbx, dy = pay - pby, dz = paz - pbz, d2 = dx * dx + dy * dy + dz * dz;
            if (d2 < min * min) {
              const d = Math.sqrt(d2) || 1e-4, nx = dx / d, ny = dy / d, nz = dz / d, push = (min - d) * 0.5;
              A.p.x += nx * push; A.p.y += ny * push; A.p.z += nz * push; B.p.x -= nx * push; B.p.y -= ny * push; B.p.z -= nz * push;
              const rel = (A.v.x - B.v.x) * nx + (A.v.y - B.v.y) * ny + (A.v.z - B.v.z) * nz;
              if (rel < 0) { const imp = -rel * 0.55; A.v.x += nx * imp; A.v.y += ny * imp; A.v.z += nz * imp; B.v.x -= nx * imp; B.v.y -= ny * imp; B.v.z -= nz * imp; }
              V.n.set(nx, ny, nz);
              V.ro.set(ax * offA * ka, ay * offA * ka, az * offA * ka); V.b.crossVectors(V.ro, V.n); A.w.addScaledVector(V.b, push * 3);
              V.ro.set(bx.x * offB * kb, bx.y * offB * kb, bx.z * offB * kb); V.b.crossVectors(V.ro, V.n); B.w.addScaledVector(V.b, -push * 3);
            }
          }
        }
      }
    }
    /* bord du tas + mise à plat quand le grain repose */
    for (let i = 0; i < N; i++) {
      const s = state[i];
      const lim = R * 1.05, rr = Math.hypot(s.p.x, s.p.z / 0.8); if (rr > lim) { s.v.x -= (s.p.x / rr) * 30 * dt; s.v.z -= (s.p.z / rr) * 30 * dt; }
      if (s.touch && s.v.lengthSq() < 4) {
        V.z.set(0, 0, 1).applyQuaternion(s.q); const tgt = V.z.y >= 0 ? 1 : -1; V.n.set(0, tgt, 0);
        V.tq.setFromUnitVectors(V.z, V.n); V.dq.identity().slerp(V.tq, 0.05); s.q.premultiply(V.dq).normalize();
      }
    }
  }

  function draw() {
    for (let i = 0; i < N; i++) { const s = state[i]; dummy.position.copy(s.p); dummy.quaternion.copy(s.q); dummy.scale.setScalar(s.s * 1.15); dummy.updateMatrix(); beans.setMatrixAt(i, dummy.matrix); }
    beans.instanceMatrix.needsUpdate = true;
  }

  function settle(frames) { for (let f = 0; f < frames; f++) step(1 / 60, null); draw(); }

  function loop(now) {
    requestAnimationFrame(loop); if (!visible) return;
    const dt = Math.min(0.033, (now - last) / 1000 || 0.016); last = now;
    let mouse3 = null;
    if (pointer.on) { raycaster.setFromCamera(pointer, camera); if (raycaster.ray.intersectPlane(plane, hit)) mouse3 = hit; }
    step(dt, mouse3); draw();
    beans.rotation.y = Math.sin(now * 0.0002) * 0.06;
    renderer.render(scene, camera);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => { visible = es[0].isIntersecting; if (visible) start(); }, { rootMargin: '200px' }).observe(root);
  } else { visible = true; start(); }
  setUI(+inp.value);
}
